import {gql} from '@apollo/client';
import {type Filter, type GqlRequest, GqlRequestBuilder, type RequestPayload} from '@igp/shared/api';
import type {QueryGetReferralLinkConfigsArgs} from '@igp/shared/contract/pam';
import type {DocumentNode} from 'graphql';

import type {ReferralLinkConfigEntityType, ReferralLinkConfigFilterKeys, ReferralLinkConfigQueryFields} from './types';

export interface IReferralLinkConfigMutationRequestBuilder {
    buildRequest(requestPayload: RequestPayload<ReferralLinkConfigQueryFields>): GqlRequest<QueryGetReferralLinkConfigsArgs>;
    buildAddReferralLinkConfigMutation(): DocumentNode;
    buildEditReferralLinkConfigMutation(): DocumentNode;
    buildRemoveReferralLinkConfigMutation(): DocumentNode;
}

export class ReferralLinkConfigRequestBuilder
    extends GqlRequestBuilder<
        ReferralLinkConfigEntityType,
        QueryGetReferralLinkConfigsArgs,
        ReferralLinkConfigQueryFields,
        ReferralLinkConfigFilterKeys
    >
    implements IReferralLinkConfigMutationRequestBuilder
{
    public buildAddReferralLinkConfigMutation(): DocumentNode {
        return gql`
            mutation AddReferralLinkConfig($config: ReferralLinkConfigInput) {
                addReferralLinkConfig(config: $config) {
                    aal_group_name
                    license
                    referral_link_base_url
                }
            }
        `;
    }

    public buildEditReferralLinkConfigMutation(): DocumentNode {
        return gql`
            mutation EditReferralLinkConfig($config: ReferralLinkConfigInput) {
                editReferralLinkConfig(config: $config) {
                    aal_group_name
                    license
                    referral_link_base_url
                }
            }
        `;
    }

    public buildRemoveReferralLinkConfigMutation(): DocumentNode {
        return gql`
            mutation RemoveReferralLinkConfig($config: RemoveReferralLinkConfigInput) {
                removeReferralLinkConfig(config: $config) {
                    aal_group_name
                    license
                    referral_link_base_url
                }
            }
        `;
    }

    protected validateFilters(_filter: Filter<ReferralLinkConfigFilterKeys>): void {}

    protected buildQuery(fields: ReferralLinkConfigQueryFields[]): DocumentNode {
        const requiredFields: ReferralLinkConfigQueryFields[] = ['aal_group_name', 'license'];
        const fieldsToFetch = [...new Set([...requiredFields, ...fields])];
        return gql`
            query GetReferralLinkConfigs($filter: ReferralLinkConfigFilterInput, $sort: Sorting, $start: Int, $end: Int) {
                getReferralLinkConfigs(filter: $filter, sort: $sort, start: $start, end: $end) {
                    items {
                        ${this.buildQueryFields(fieldsToFetch)}
                    }
                    total_count
                }
            }
        `;
    }

    protected buildFilter(filter: Filter<ReferralLinkConfigFilterKeys>): QueryGetReferralLinkConfigsArgs {
        return {
            filter: {
                aal_group_name: this.toGQLStringFilter(filter, 'aal_group_name'),
            },
        };
    }
}
